import { AxiosRequestConfig, AxiosResponse } from "axios";
import HttpService from "./interface/HttpService";

class AuthentificationService {
  private instance: HttpService;
  private controllerName: string = 'authentication'; 

  constructor() {
    this.instance = new HttpService(this.controllerName);
  }

  public get(url: string = '', config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.instance.get(url, config);
  }

  public post(url: string = '', data: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.instance.post(url, data, config);
  }

  public put(url: string = '', data: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.instance.put(url, data, config);
  }

  public delete(url: string = '', config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.instance.delete(url, config);
  }

  public resendOtp(email: string): Promise<AxiosResponse> {
    return this.post('resend-otp', { email });
  }

  public verifyOtp(email: string, otp: string): Promise<AxiosResponse> {
    return this.post('verify-otp', { email, otp });
  }
}

export default AuthentificationService;